export default {
    env: process.env.REACT_APP_ENV,
    envType: process.env.REACT_APP_ENV_TYPE
}